import { IsInstanceOf } from "@utils/class-validator/class-validator-constraints";
import { Type } from "class-transformer";
import { IsArray, IsOptional, IsString, ValidateNested } from "class-validator";
import { TemplatePropertyDto } from "./property/template-property.dto";

export class TemplateDto {
  @IsString()
  name!: string;

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  supportedCountries!: string[];

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  supportedLanguages?: string[];

  @IsOptional()
  @IsInstanceOf(TemplatePropertyDto)
  @ValidateNested({ each: true })
  @Type(() => TemplatePropertyDto)
  properties?: TemplatePropertyDto;
}
